import { DeviceFloorplanDisplayDto, DeviceSettingDto } from '@api-client';
import { DeviceFloorplanIcon, DeviceFloorplanType } from '@common';

export const deviceFloorplanTypeOptions = Object.values(DeviceFloorplanType).map(
  (item) => ({
    value: item.key,
    label: item.label,
  }),
);

export const deviceFloorplanIconOptions = Object.values(DeviceFloorplanIcon).map(
  (item) => ({
    value: item.key,
    label: item.label,
  }),
);

export function resolveDeviceFloorplanDisplay(
  setting?: DeviceSettingDto | null,
) {
  return toResolvedDeviceFloorplanDisplay(setting?.floorplan);
}

export function toResolvedDeviceFloorplanDisplay(
  display?: DeviceFloorplanDisplayDto | null,
) {
  const typeMeta = display?.type ? DeviceFloorplanType[display.type] : null;
  const iconMeta = display?.icon ? DeviceFloorplanIcon[display.icon] : null;

  return {
    type: display?.type || 'DISPLAY',
    typeLabel: typeMeta?.label || DeviceFloorplanType.DISPLAY.label,
    icon: display?.icon || null,
    iconLabel: iconMeta?.label || '기본 아이콘',
    iconName:
      iconMeta?.icon ||
      typeMeta?.defaultIcon ||
      DeviceFloorplanType.DISPLAY.defaultIcon,
  };
}
